module.exports = __webpack_public_path__ + "static/media/barbele.a02eafb8.jpg";